// extracted by mini-css-extract-plugin
export default {"main-content":"Lead_main-content__ORItX","lead":"Lead_lead__Hh0ok"};